import { PageWithScene } from "@/components/PageWithScene/PageWithScene";

export function PageNotFound() {
  return <PageWithScene heading="Side ikke funnet" scene="Alice-Bob" />;
}
